<template>
    <div class="projects-page-outer">
        <div id="admin-page">
            <TheAdminPageModal/>
            <TheNavbar/>
            <div id="configurator-group">
                <vue-custom-scrollbar class="sidenav ap-sidenav">
                    <SidebarAdminPage/>
                </vue-custom-scrollbar>
                <div id="workspace-ap">
                        <router-view name="workspace"></router-view>
                </div>
            </div>
        </div>
        <Spinner v-show="isLoading"/>
    </div>
</template>

<script>
    import TheNavbar from "../UI/Navbar/TheNavbar.vue";
    import SVGAdminEditRow from "./SVG/SVGAdminEditRow.vue";
    import SVGAdminDeleteRow from "./SVG/SVGAdminDeleteRow.vue";
    import Spinner from "./Spinner";
    import SidebarAdminPage from "./Sidebar/AdminPage/SidebarAdminPage";
    import vueCustomScrollbar from 'vue-custom-scrollbar';
    import TheAdminPageModal from "./Modal/TheAdminPageModal";
    import {bus} from "../vue_bus";

    export default {
        name: "AdminPage",
        components: {
            TheAdminPageModal,
            SidebarAdminPage,
            Spinner,
            SVGAdminDeleteRow,
            SVGAdminEditRow,
            TheNavbar,
            vueCustomScrollbar
        },
        computed: {
            isLoading() {
                return !!this.$store.getters["IN_PROGRESS"];
            }
        },
        methods:{
            scrollReachEnd(event){
                bus.$emit('workspaceScrollReachEnd');
            }
        }
    }
</script>

<style>
    #admin-page {
        display: block;
        width: 100%;
        height: 100%;
    }

    #admin-page-workspace {
        display: block;
        height: calc(100% - 82px);
    }

    .ap-sidenav {
        width: auto !important;
    }

    .ap-workspace-head {
        display: grid;
        grid-template-columns: 345px max-content;
        grid-column-gap: 10px;
        padding: 40px;
    }

    .ap-workspace-label {
        font-size: 32px;
        font-weight: bold;
        /*color: #303030;*/
        display: grid;
        grid-template-columns: max-content max-content;
        grid-column-gap: 10px;
    }

    .ap-workspace-label-btn {
        color: #BDBDBD;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        user-select: none;
    }

    .ap-workspace-label-btn:hover {
        color: #A3A3A3;
    }

    .ap-workspace-label-btn:active {
        color: #BDBDBD;
    }

    .ap-add-left-margin {
        margin-left: 100px;
    }

    .ap-search {
        position: relative;
        display: flex;
    }

    .ap-search:before {
        content: "";
        position: absolute;
        left: 10px;
        top: 0;
        bottom: 0;
        width: 20px;
        background: url("data:image/svg+xml,%3Csvg%20width%3D%2720%27%20height%3D%2720%27%20viewBox%3D%270%200%2016%2016%27%20fill%3D%27none%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%3E%3Cpath%20d%3D%27M5.99967%201.3335C3.43024%201.3335%201.33301%203.43073%201.33301%206.00016C1.33301%208.5696%203.43024%2010.6668%205.99967%2010.6668C7.16501%2010.6668%208.22968%2010.2322%209.04915%209.521L9.33301%209.80485V10.6668L13.057%2014.3908C13.425%2014.7588%2014.0223%2014.7588%2014.3903%2014.3908C14.7583%2014.0228%2014.7583%2013.4255%2014.3903%2013.0575L10.6663%209.3335H9.80436L9.52051%209.04964C10.2317%208.23017%2010.6663%207.16549%2010.6663%206.00016C10.6663%203.43073%208.56911%201.3335%205.99967%201.3335ZM5.99967%202.66683C7.84852%202.66683%209.33301%204.15132%209.33301%206.00016C9.33301%207.84901%207.84852%209.3335%205.99967%209.3335C4.15083%209.3335%202.66634%207.84901%202.66634%206.00016C2.66634%204.15132%204.15083%202.66683%205.99967%202.66683Z%27%20fill%3D%27%23939393%27%2F%3E%3C%2Fsvg%3E") center / contain no-repeat;
    }

    .ap-search-input {
        padding: 10px 10px 10px 40px;
        border: 1px solid #BDBDBD;
        width: 200px
    }

    .ap-search-input:hover {
        border-color: #828282;
    }

    .ap-search-input:focus {
        border-color: #828282;
    }

    .ap-workspace-table-container {
        margin: 0 40px;
    }

    .edit-button-group {
        display: grid;
        grid-template-columns: auto auto;
    }

    .field-edit {
        width: 80px;
    }

    .table-svg-button {
        cursor: pointer;
        user-select: none;
        color: #999999;
    }

    .table-svg-button:hover{
        color: #626262;
    }

    .table-svg-button:active{
        color: #303030;
    }

    table {
        border-collapse: collapse;
        width: 100%;
        color: #626262;
    }

    th, td {
        padding: 8px;
        text-align: left;
        border-bottom: 1px solid #ddd;
    }

    .body-tr:hover {
        background-color: #E9E9E9;
    }

    .ap-table-img {
        max-width: 150px;
        max-height: 150px;
        border-radius: 4px;
        user-select: none;
    }

    .ap-sidebar-container {
        display: grid;
        grid-template-rows: auto max-content;
        height: 100%;

    }
    .ap-sidebar-menu-container {
        display: block;
        width: 100%;
        height: auto;
        margin: 80px 0;
    }

    .ap-sidebar-menu-element {
        display: grid;
        grid-template-columns: 50px auto;
        grid-column-gap: 10px;
        color: #626262;
        font-size: 18px;
        padding: 20px 40px;
        cursor: pointer;
        user-select: none;
    }

    .ap-sidebar-menu-element:hover {
        background-color: #F2F2F2;
    }

    .active-page {
        background-color: #D83336 !important;
        color: white !important;
    }

    .ap-sidebar-menu-element-icon {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ap-sidebar-svg {
        width: 22px;
        height: 22px;
    }

    .ap-sidebar-svg-fa {
        width: 19px;
        height: 19px;
    }

    .ap-sidebar-menu-configurator-btn {
        display: grid;
        grid-template-columns: 50px auto;
        grid-column-gap: 10px;
        color: #626262;
        font-size: 18px;
        padding: 20px 40px;
        cursor: pointer;
        user-select: none;
    }

    .ap-sidebar-menu-configurator-btn:hover {
        background-color: #F2F2F2;
    }

    .ap-sidebar-menu-configurator-btn:active {
        background-color: #E2E2E2;
    }

    .ap-modal-checkbox-grid {
        display: grid;
        grid-template-columns: max-content auto;
        grid-column-gap: 5px;
        height: 36px;
    }

    .ap-modal-checkbox-grid-element {
        display: flex;
        align-items: center;
    }

    .button-change {
        background-color: #383838;
        padding: 5px 10px;
        color: white;
        font-weight: bold;
        width: max-content;
        cursor: pointer;
        user-select: none;
    }

</style>
